import React from "react";
import { useDispatch } from "react-redux";

import GlobalStyle from "GlobalStyle";

import { dimensions as dimensionsAction } from "actions";

import PageAbout from "Components/Pages/About";

function App() {
   const dispatch = useDispatch();

   function onResize() {
      dispatch({
         type: dimensionsAction.sync,
         payload: {
            width: window.innerWidth,
            height: window.innerHeight,
         },
      });
   }

   window.addEventListener("resize", onResize);
   return (
      <div className="App">
         <GlobalStyle></GlobalStyle>
         <PageAbout />
      </div>
   );
}

export default App;
